import { render, staticRenderFns } from "./CandidateFeed.vue?vue&type=template&id=5a018214"
import script from "./CandidateFeed.vue?vue&type=script&lang=js"
export * from "./CandidateFeed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a018214')) {
      api.createRecord('5a018214', component.options)
    } else {
      api.reload('5a018214', component.options)
    }
    module.hot.accept("./CandidateFeed.vue?vue&type=template&id=5a018214", function () {
      api.rerender('5a018214', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/candidates/components/CandidateFeed.vue"
export default component.exports